import React, { useEffect, useRef } from 'react';

const MOBILE_MEDIA_QUERY = '(max-width: 768px), (pointer: coarse), (prefers-reduced-motion: reduce)';

const SolanaCursorAura: React.FC = () => {
  const auraRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const media = window.matchMedia(MOBILE_MEDIA_QUERY);
    if (media.matches) return;

    const auraEl = auraRef.current;
    if (!auraEl) return;

    let animationFrame = 0;
    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight / 2;
    let currentX = mouseX;
    let currentY = mouseY;

    const handleMove = (event: MouseEvent) => {
      mouseX = event.clientX;
      mouseY = event.clientY;
    };

    const animate = () => {
      currentX += (mouseX - currentX) * 0.12;
      currentY += (mouseY - currentY) * 0.12;

      auraEl.style.transform = `translate3d(${currentX}px, ${currentY}px, 0)`;
      animationFrame = window.requestAnimationFrame(animate);
    };

    window.addEventListener('mousemove', handleMove, { passive: true });
    animationFrame = window.requestAnimationFrame(animate);

    return () => {
      window.removeEventListener('mousemove', handleMove);
      window.cancelAnimationFrame(animationFrame);
    };
  }, []);

  return (
    <div
      ref={auraRef}
      aria-hidden="true"
      className="solana-cursor-aura"
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        width: '2px',
        height: '2px',
        pointerEvents: 'none',
        zIndex: 0,
        transform: 'translate3d(-100vw, -100vh, 0)',
      }}
    >
      <div
        style={{
          position: 'absolute',
          left: '-110px',
          top: '-110px',
          width: '220px',
          height: '220px',
          borderRadius: '50%',
          background: 'radial-gradient(circle at 30% 30%, rgba(153, 69, 255, 0.35), rgba(34, 210, 255, 0.22) 42%, rgba(20, 241, 149, 0.12) 62%, rgba(20, 241, 149, 0) 74%)',
          filter: 'blur(18px)',
          opacity: 0.75,
          animation: 'solanaAuraPulse 3.4s ease-in-out infinite',
        }}
      />
      <div
        style={{
          position: 'absolute',
          left: '-42px',
          top: '-42px',
          width: '84px',
          height: '84px',
          borderRadius: '50%',
          border: '1px solid rgba(102, 191, 255, 0.28)',
          background: 'radial-gradient(circle, rgba(255, 255, 255, 0.18) 0%, rgba(153, 69, 255, 0.08) 35%, rgba(153, 69, 255, 0) 72%)',
          boxShadow: '0 0 25px rgba(153, 69, 255, 0.2)',
        }}
      />
    </div>
  );
};

export default SolanaCursorAura;
